import { styled } from 'styled-components';
import { Card, Input } from 'antd';

export const ContentCard = styled(Card)`
  width: 640px;
  max-width: 100%;
  margin: 0 auto;
`;

export const SectionGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 24px;
`;

export const SectionCard = styled.section`
  background: #fff;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  padding: 24px;
`;

export const CardTitle = styled.h2`
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
`;

export const AdvertisementCodeText = styled.span`
  display: block;
  margin-bottom: 20px;
  color: #8c8c8c;
  font-size: 13px;
`;

export const SubSection = styled.div`
  & + & {
    margin-top: 28px;
  }
`;

export const SectionHeading = styled.h3`
  margin: 0;
  font-size: 15px;
  font-weight: 600;
  color: rgba(0, 0, 0, 0.88);
`;

export const JobNumberRowGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(160px, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;

  &:last-of-type {
    border-bottom: none;
  }
`;

export const RowActions = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
`;

export const ListHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const JobNumberSearch = styled(Input)`
  max-width: 280px;
  margin-bottom: 12px;
`;

export const EmptyHint = styled.p`
  margin: 16px 0;
  color: #8c8c8c;
  font-size: 13px;
  text-align: center;
`;

export const PaginationFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const UploadHint = styled.p`
  margin: 0 0 16px;
  color: #8c8c8c;
  font-size: 13px;
`;

export const UploadFooter = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  margin-top: 16px;
`;

export const UploadPreviewBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;

export const UploadPreviewSummary = styled.p`
  margin: 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.88);
`;

export const ScheduleGrid = styled.div`
  display: grid;
  grid-template-columns: 64px 1fr auto 1fr;
  align-items: center;
  row-gap: 12px;
  column-gap: 12px;
  margin-top: 16px;
`;

export const WeekdayLabelCell = styled.div`
  font-weight: 600;
`;

interface TimeInputProps {
  $dirty?: boolean;
}

export const TimeInput = styled.input<TimeInputProps>`
  width: 100%;
  padding: 4px 11px;
  height: 32px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font: inherit;
  background: ${({ $dirty }) => ($dirty === true ? '#fffbe6' : '#fff')};
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #4096ff;
    box-shadow: 0 0 0 2px rgba(5, 145, 255, 0.1);
  }

  &:disabled {
    background: ${({ $dirty }) => ($dirty === true ? '#fffbe6' : '#f5f5f5')};
    cursor: not-allowed;
  }
`;

export const ToggleSection = styled.div`
  margin-top: 20px;
`;

export const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 360px;

  & + & {
    margin-top: 12px;
  }
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: rgba(0, 0, 0, 0.88);
`;

export const ToggleNote = styled.p`
  margin: 0 0 12px;
  color: #8c8c8c;
  font-size: 12px;
  line-height: 1.6;
`;

export const ScheduleFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
`;
